/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { SalesStrictHttpResponse } from '../../sales-strict-http-response';
import { SalesRequestBuilder } from '../../sales-request-builder';

import { SalesPriceListCategoryCreateDto } from '../../models/sales-price-list-category-create-dto';
import { SalesPriceListCategoryResponseDto } from '../../models/sales-price-list-category-response-dto';

export interface PriceListCategoriesControllerCreate$Params {

/**
 * The tenant identifier.
 */
  tenant: string;
      body: SalesPriceListCategoryCreateDto
}

export function priceListCategoriesControllerCreate(http: HttpClient, rootUrl: string, params: PriceListCategoriesControllerCreate$Params, context?: HttpContext): Observable<SalesStrictHttpResponse<SalesPriceListCategoryResponseDto>> {
  const rb = new SalesRequestBuilder(rootUrl, priceListCategoriesControllerCreate.PATH, 'post');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as SalesStrictHttpResponse<SalesPriceListCategoryResponseDto>;
    })
  );
}

priceListCategoriesControllerCreate.PATH = '/o2-sales/price-list-categories/{tenant}';
